@if (leg.official === false) {
  <div class="row w-100">
    <div class="unit_columns">
      <ul class="d-flex flex-column align-self-center text-center units">
        @for (selection of leg.selections; track $index) {
          <li class="row w-100 leg-units">
            <span class="col col-6 key-box">
              <span class="key">
                <span class="key">{{selection.name}}</span>
              </span>
            </span>
            @if (selection.unit_distributions.length > 0) {
              <span class="col col-6 value-box">
                <strong class="cb-bold amount">{{getUnits(selection.unit_distributions) | formatUnits}}</strong>
                @if (getUnits(selection.unit_distributions) != 0) {
                  <span class="value" [transloco]="'poolUnitsDist.UNIT'"></span>
                }
              </span>
            }
          </li>
        }
      </ul>
    </div>
  </div>
}
